// 精简版日志封装，兼容 Edge / Client / Node 三种运行时（底层走 pino / Edge 回退）
// 输出单行 JSON，避免 SLS 按行采集时一条日志被拆成多条
import { EdgeLoggerFilterConfig } from '@/config/log-filter';
import { baseLogger } from '@/lib/logger';
import { mergeMeta } from '@/lib/log-meta';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const createLogMethod = (level: LogLevel) => {
    return (message: string, ...meta: any[]) => {

        // 直接使用metadata中的key作为过滤键
        const keyHolder = meta.find(m => m?.metadata?.key);
        const shouldLog = keyHolder ? EdgeLoggerFilterConfig.get(keyHolder.metadata.key) : undefined;

        // 如果有配置项且shouldLog为false，则跳过日志输出
        if (shouldLog === false) return;

        const obj = mergeMeta(meta);

        if (Object.keys(obj).length > 0) {
            (baseLogger as any)[level](obj, message);
        } else {
            (baseLogger as any)[level](message);
        }
    };
};

const logger = {
    error: createLogMethod('error'),
    warn: createLogMethod('warn'),
    info: createLogMethod('info'),
    debug: createLogMethod('debug'),
    log: createLogMethod('info')
};

export default logger;
